<div class="flex items-center justify-between mt-10">
  <h3 class="text-lg font-semibold">Add product</h3>
</div>
<div class="-mx-2.5 mt-5 flex flex-wrap gap-y-5">
  <div class="w-1/2 px-2.5">
    @if (categoryChoices) {
      <app-select [height]="'11'" [control]="form.controls.category" [choices]="categoryChoices" label="Category"></app-select>
    }
  </div>
  <div class="w-1/2 px-2.5">
    <app-text-input [mask]="'separator.2'" [thousandSeparator]="','"  [control]="form.controls.amount" [name]="'amount'" [placeholder]="'0.00'" [label]="'&pound; Amount Due'"></app-text-input>
  </div>
  <div class="w-full px-2.5">
    <app-textarea [control]="form.controls.description" [name]="'description'" [placeholder]="'Description'" [label]="'Description'"></app-textarea>
  </div>
  <div class="w-1/2 px-2.5">
    <app-date-picker [control]="form.controls.date_due" [label]="'Date Due'"></app-date-picker>
  </div>
  <div class="w-1/2 px-2.5">
    <app-text-input [mask]="'separator.2'" [thousandSeparator]="','"  [control]="form.controls.amount_paid" [name]="'amount_paid'" [placeholder]="'0.00'" [label]="'&pound; Amount Paid'"></app-text-input>
  </div>
  <div class="w-1/2 px-2.5">
    <app-date-picker [control]="form.controls.date_paid" [label]="'Date Paid'"></app-date-picker>
  </div>
  <div class="w-1/2 px-2.5">
    <app-checkbox [control]="form.controls.is_reservation_fee" [label]="'Is Reservation Fee'"></app-checkbox>
  </div>
  <div class="flex flex-row w-full justify-between align-bottom">
    <div class=" flex justify-end px-2.5">
      <app-button [label]="'Add Payment'" [disabled]="!form.valid || form.pristine" (click)="save()"></app-button>
    </div>
  </div>
</div>
